.noResults {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  text-align: center;
  height: 100%;
  width: 100%;
  position: absolute;

  @include themify($themes) {
    color: themed("neutral-primary");
  }

  :first-child {
    font-size: 16px;
    margin-bottom: 12px;
  }

  :last-child {
    font-size: 14px;
    margin-bottom: unset;
  }
}
